import { HStack } from '@chakra-ui/react';
import { SuggestionsButtonList } from '../ButtonList';
import { SuggestionsButton } from '../Button';
import type { InterestLevel } from '@habity/types';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';

interface SpeculatorCurationFilter {
  key: string;
  label: string;
  interests: InterestLevel[];
}

const speculatorCurationFilters: SpeculatorCurationFilter[] = [
  {
    key: 'showed_interest',
    label: 'Anmält intresse',
    interests: ['showed_interest', 'showed_strong_interest'],
  },
  {
    key: 'booked_viewing',
    label: 'Bokat visning',
    interests: ['booked_viewing', 'attended_viewing'],
  },
  {
    key: 'followed_bidding',
    label: 'Följer budgivning',
    interests: ['followed_bidding'],
  },
  {
    key: 'placed_bid',
    label: 'Lagt bud',
    interests: ['placed_bid', 'paused_bidding'],
  },
];

export function SpeculatorCurations() {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();

  const existingInterests = searchParams?.getAll('interests') ?? [];
  const hasAnyFilter = existingInterests.length > 0;

  function selectFilter(filter: SpeculatorCurationFilter | null) {
    const params = new URLSearchParams(searchParams?.toString());
    params.delete('interests');

    if (filter) {
      // If the filter is already active, deselect it (back to "Alla")
      const isAlreadyActive = filter.interests.every((i) =>
        existingInterests.includes(i)
      );
      if (!isAlreadyActive) {
        for (const interest of filter.interests) {
          params.append('interests', interest);
        }
      }
    }

    router.replace(`${pathname}?${params.toString()}`, { scroll: false });
  }

  function getIsActive(filter: SpeculatorCurationFilter) {
    if (existingInterests.length !== filter.interests.length) return false;
    return filter.interests.every((i) => existingInterests.includes(i));
  }

  return (
    <HStack mb="1">
      <SuggestionsButtonList>
        <SuggestionsButton
          label="Alla"
          isActive={!hasAnyFilter}
          onClick={() => selectFilter(null)}
        />
        {speculatorCurationFilters.map((f) => (
          <SuggestionsButton
            key={f.key}
            label={f.label}
            isActive={getIsActive(f)}
            onClick={() => selectFilter(f)}
          />
        ))}
      </SuggestionsButtonList>
    </HStack>
  );
}
